// Function to calculate remaining hours and minutes until cut-off time in Central Time (CT)
function calculateRemainingTimeCT() {
    const cutOffTime = 14; // Cut-off time in CT (3:00 PM) (14:01 to 14.59 - Consider as a 15)
    const now = new Date();
    const currentUTCHour = now.getUTCHours();
    const currentUTCMinute = now.getUTCMinutes();    
    const currentCTHour = (currentUTCHour - 5 + 24) % 24; // Convert UTC to CT
    // console.log(currentCTHour+"-"+currentUTCMinute);
    const currentCTMinute = currentUTCMinute;
    const cutOffHour = currentCTHour < cutOffTime ? cutOffTime : cutOffTime + 24;

    let remainingHours = cutOffHour - currentCTHour;
    let remainingMinutes = 59 - currentCTMinute;

    return { hours: remainingHours, minutes: remainingMinutes };
}

// Function to check the weekend
function checkWeekend() {
  const today = new Date();
  const options = { weekday: 'long', timeZone: 'America/Chicago' };
  const dayOfWeek = today.toLocaleString('en-US', options);
  // Get the current hour in CT
  const currentHour = calculateRemainingTimeCT();
  let weekendDay = "";
  let nextBusinessDay = "";
  let noOfDays = "";

  if (dayOfWeek.toLowerCase() === 'friday' && parseInt(currentHour) < 15) {
      // Add two days to the current date
      nextBusinessDay = new Date(today);
      nextBusinessDay.setDate(nextBusinessDay.getDate() + 2);        
  } else if ((dayOfWeek.toLowerCase() === 'friday' && parseInt(currentHour.hours) >= 15) || dayOfWeek.toLowerCase() == 'saturday') {
      // Add two days to the current date
      nextBusinessDay = new Date(today);
      nextBusinessDay.setDate(nextBusinessDay.getDate() + 3);  
      noOfDays = '2 days ';
  } else if (dayOfWeek.toLowerCase() == 'sunday') {
      // Add two days to the current date
      nextBusinessDay = new Date(today);
      nextBusinessDay.setDate(nextBusinessDay.getDate() + 2);  
      noOfDays = '1 day ';
  }

  if(nextBusinessDay != "") {
    // Format the date (e.g., "Jan 01")
    const formattedDate = nextBusinessDay.toLocaleString('en-US', { month: 'short', day: '2-digit', ...options });
    // console.log(formattedDate);
    weekendDay = "Want it "+ formattedDate + " by 3PM CT?";     
  }
  else {
    weekendDay = "Next Day Delivery";
  }
  

  return { day: weekendDay, noofdays: noOfDays };
}

// Function to format the remaining time message with exact hours and minutes
function formatRemainingTimeExact(hours, minutes) {
    let timeMessage = '';

    // Display remaining hours
    if (hours > 0) {
        timeMessage += `${hours} Hour(s)`;
    }

    // Display remaining minutes
    if (minutes > 0) {
        if (timeMessage !== '') {
            timeMessage += ' and ';
        }
        timeMessage += `${minutes} Minute(s)`;
    }

    // Add suffix
    if (timeMessage === '') {
        timeMessage = 'less than a minute';
    }

    return timeMessage;
}

// Function to display the message
function displayRemainingTimeMessageExact() {
    const remainingTime = calculateRemainingTimeCT();    
    const weekendDay = checkWeekend();
    const timeMessage = formatRemainingTimeExact(remainingTime.hours, remainingTime.minutes);  
    let parentID = document.getElementById('rw-additional-info');
    parentID.querySelector(".advantage .advantage__wrapper .advantage__content .advantage__text").innerHTML = `Order within ${timeMessage} and choose Next Day Shipping at checkout.`;    
    //console.log(`Order within ${timeMessage} and choose Next Day Shipping at checkout.`);
    if(weekendDay != "") {  
      parentID.querySelector(".advantage .advantage__wrapper .advantage__content .advantage__title.advantage__title--colored").innerHTML = `${weekendDay.day}`;  
      parentID.querySelector(".advantage .advantage__wrapper .advantage__content .advantage__text").innerHTML = `Order within ${weekendDay.noofdays} ${timeMessage} and choose Next Day Shipping at checkout.`; 
    }
}

displayRemainingTimeMessageExact();